// Beneficiary case-studies — collected via Voice AI agents
// source: "Voice AI"

export const STORIES = [
  {
    id: "ananya",
    name: "Ananya Sharma",
    pillar: "stem",
    location: "Karnataka",
    partner: "Agastya International Foundation",
    source: "Voice AI",
    headline: "The Lab-on-a-Tab that turned fear of science into love",
    quote:
      "I used to copy science from the board without understanding. The mobile lab let me build a circuit with my own hands — now I want to be an engineer.",
    impact: "Top of her class in science; selected for the district science fair",
  },
  {
    id: "rohit",
    name: "Rohit Verma",
    pillar: "digital",
    location: "Uttar Pradesh",
    partner: "Muskaan Dreams (with Motorola)",
    source: "Voice AI",
    headline: "From no computer at home to writing his first AI program",
    quote:
      "Before this, I had never touched a laptop. Today I built a small chatbot in our coding class and taught my younger sister too.",
    impact: "Completed coding & AI module; mentoring 4 peers as a digital champion",
  },
  {
    id: "priya",
    name: "Priya Nair",
    pillar: "employability",
    location: "Maharashtra",
    partner: "TechnoServe India",
    source: "Voice AI",
    headline: "A first-generation graduate lands an IT-ITES role",
    quote:
      "The skilling programme gave me communication and computer skills. I cleared three interviews and now support customers for a tech firm.",
    impact: "₹21,000/month — first salaried job in her family",
  },
  {
    id: "kavya",
    name: "Kavya R.",
    pillar: "digital",
    location: "Gujarat",
    partner: "YUVA Unstoppable",
    source: "Voice AI",
    headline: "A shared tablet kept her in school",
    quote:
      "When my school got tablets, learning became fun. I could revise at home and my attendance improved — my parents are proud.",
    impact: "Attendance up from 61% to 92%; cleared Class 10 with distinction",
  },
  {
    id: "suresh",
    name: "Suresh Kumar",
    pillar: "employability",
    location: "Puducherry",
    partner: "TNS India Foundation",
    source: "Voice AI",
    headline: "Campus-to-corporate readiness opened a factory-floor career",
    quote:
      "The programme taught me workplace etiquette and machine basics. I was placed in a manufacturing unit right after my diploma.",
    impact: "Placed as a junior technician at ₹18,500/month",
  },
  {
    id: "meena",
    name: "Meena Thomas",
    pillar: "sustainability",
    location: "Kerala",
    partner: "Dream India Network",
    source: "Voice AI",
    headline: "Reviving millet brought income back to the hills",
    quote:
      "We had stopped growing millet. With training and a buyer link, our farmer group sells value-added millet products in the city now.",
    impact: "Household income up 2.5×; 38 families in the collective",
  },
];

export const SOURCE_META = {
  "Voice AI": { color: "#7C3AED", bg: "bg-violet-50", text: "text-violet-700", icon: "Mic" },
};
